import { Component, Input, inject } from '@angular/core';
import { combineLatest, Observable, map } from 'rxjs';
import { PayeeCasesService } from '../payee-cases.service';
import { TaskRecipient } from '../types';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

type CaseQuickFilter = 'all' | 'todo';

@Component({
  selector: 'payee-case-quick-filters',
  templateUrl: './case-quick-filters.component.html',
  styleUrls: ['./case-quick-filters.component.scss'],
  imports: [PayeeButtonComponent, AsyncPipe, TranslateModule],
})
export class CaseQuickFiltersComponent {
  private payeeCasesService = inject(PayeeCasesService);

  @Input() showTodoSubTabs = false;

  readonly options: CaseQuickFilter[] = ['all', 'todo'];

  readonly todoSubTabOptions: TaskRecipient[] = ['ADMIN', 'ATTORNEY'];

  readonly selectedOption$: Observable<CaseQuickFilter>;
  readonly selectedTodoSubTab$: Observable<TaskRecipient>;

  constructor() {
    this.selectedOption$ = this.payeeCasesService.has_task.pipe(
      map((hasTask) => (hasTask === 1 ? 'todo' : 'all')),
    );

    this.selectedTodoSubTab$ = combineLatest([
      this.payeeCasesService.has_task,
      this.payeeCasesService.task_recipient,
    ]).pipe(
      map(([hasTask, taskRecipient]) => {
        if (hasTask !== 1) {
          return 'ADMIN';
        }

        return taskRecipient ?? 'ADMIN';
      }),
    );
  }

  selectOption(option: CaseQuickFilter): void {
    if (option === 'todo') {
      this.payeeCasesService.has_task.next(1);

      if (
        this.showTodoSubTabs &&
        !this.payeeCasesService.task_recipient.value
      ) {
        this.payeeCasesService.task_recipient.next('ADMIN');
      }
    } else {
      this.payeeCasesService.has_task.next(null);
      this.payeeCasesService.task_recipient.next(null);
    }
  }

  selectTodoSubTab(option: TaskRecipient): void {
    this.payeeCasesService.task_recipient.next(option);
  }
}
